export class Company {
    public username: string;
    public id: number;
    public name: string;
    public companyName: string;
    public tin: string;
    public address: string;
    public description: string;
  }
